var React = require('react');

function AddressIcon (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0}),React.createElement("title",{"key":1},"address-icon"),React.createElement("path",{"d":"M170.5,6.3A121.66,121.66,0,0,0,49,127.8C49,211,157.72,333.05,162.37,338.16a10.9,10.9,0,0,0,16.26,0C183.28,333,292,211,292,127.8A121.66,121.66,0,0,0,170.5,6.3Zm0,182.64a61.14,61.14,0,1,1,61.14-61.14A61.25,61.25,0,0,1,170.5,188.94Z","transform":"translate(-49 -6.3)","key":2})]);
}

AddressIcon.defaultProps = {"id":"Capa_1","data-name":"Capa 1","viewBox":"0 0 243 335.5"};

module.exports = AddressIcon;

AddressIcon.default = AddressIcon;
